import { NavigateFunction } from "react-router-dom";
import { ROUTE_PATHS } from "../../../routes/paths";
import { SetPasswordFormData } from "./config";

export function handleSetPasswordSuccess(navigate: NavigateFunction): void {
  navigate(ROUTE_PATHS.AUTH.LOGIN);
}

export function getSetPasswordPayload(
  data: SetPasswordFormData
): { password: string } {
  return {
    password: data.password,
  };
}

export function validateToken(token: string | null): boolean {
  return Boolean(token);
}

export const TOKEN_ERROR_MESSAGE =
  "Invalid or missing token. Please request a new password reset link.";
